import React from "react";
import Container from "../components/Container";
import { RiRefund2Line } from "react-icons/ri";
import "./styles/policy.css";

const RefundPolicy = () => {
  return (
    <>
    

      <Container class1="policy-wrapper">
        {/* Top header bar */}
        <div className="policy-hero">
          <div className="policy-heroLeft">
            <p className="policy-kicker">Policy</p>
            <h1 className="policy-title">Refund Policy</h1>
            <p className="policy-sub">
              This Refund Policy explains when you can request a refund, how
              refunds are processed, and what items are eligible.
            </p>
          </div>

          <div className="policy-heroRight" aria-hidden="true">
            <div className="policy-iconWrap">
              <RiRefund2Line className="policy-icon" />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="policy-card">
          <div className="policy-body">
            <h2>1. Overview</h2>
            <p>
              At Kupto, we aim to deliver high-quality products and services. If
              something goes wrong, we’ll work with you to resolve it quickly.
              Refund eligibility depends on the product type and the reason for
              the request.
            </p>

            <h2>2. Eligibility for Refunds</h2>
            <ul>
              <li>
                <strong>Standard products:</strong> Refund requests must be made
                within <strong>5 days</strong> of delivery, and items should be
                unused and in original packaging.
              </li>
              <li>
                <strong>Custom printed items:</strong> Refunds are only available
                if there is a <strong>production defect</strong>, a{" "}
                <strong>printing error</strong>, or you received the{" "}
                <strong>wrong item</strong>.
              </li>
              <li>
                <strong>Services (design/branding):</strong> If work has already
                started, refunds may be partial depending on progress.
              </li>
            </ul>

            <h2>3. Non-Refundable Cases</h2>
            <ul>
              <li>Change of mind after production has started.</li>
              <li>Customer-provided artwork issues (low resolution, wrong size, wrong spelling).</li>
              <li>Incorrect delivery details provided by the customer.</li>
              <li>Normal color variation between screen display and printed output.</li>
              <li>Damage caused after delivery due to misuse or poor handling.</li>
            </ul>

            <h2>4. How to Request a Refund</h2>
            <p>Please contact us with the following details:</p>
            <ul>
              <li>Order number</li>
              <li>Product name and quantity</li>
              <li>Reason for refund request</li>
              <li>Photos/videos showing the issue (if applicable)</li>
            </ul>

            <div className="policy-contactBox">
              <p className="policy-contactTitle">Contact Kupto Support</p>
              <p className="policy-contactLine">
                <strong>Email:</strong> kupto2020@gmail.com
              </p>
              <p className="policy-contactLine">
                <strong>Phone / WhatsApp:</strong> +256 200 949 142
              </p>
              <p className="policy-contactLine">
                <strong>Working Hours:</strong> Monday – Saturday, 8:00 AM – 7:00 PM
              </p>
            </div>

            <h2>5. Refund Processing Time</h2>
            <p>
              Once approved, refunds are processed within{" "}
              <strong>4 working days</strong>. Depending on the payment method,
              your bank/mobile money provider may take additional time to reflect
              the refund.
            </p>

            <h2>6. Exchanges / Reprints</h2>
            <p>
              For printing defects or incorrect items, we may offer a{" "}
              <strong>reprint</strong> or <strong>replacement</strong> instead of
              a refund where appropriate. This is often the fastest way to resolve
              print-related issues.
            </p>

            <h2>7. Policy Updates</h2>
            <p>
              We may update this Refund Policy from time to time. Changes will be
              posted on this page with an updated effective date.
            </p>

            <p className="policy-footNote">
              <strong>Effective date:</strong> {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
      </Container>
    </>
  );
};

export default RefundPolicy;
